import { render, staticRenderFns } from "./OnlCgformHeadList.vue?vue&type=template&id=1fedd417&scoped=true&"
import script from "./OnlCgformHeadList.vue?vue&type=script&lang=js&"
export * from "./OnlCgformHeadList.vue?vue&type=script&lang=js&"
import style0 from "./OnlCgformHeadList.vue?vue&type=style&index=0&id=1fedd417&scoped=true&lang=css&"
import style1 from "./OnlCgformHeadList.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fedd417",
  null
  
)

export default component.exports